import { Link } from "react-router-dom";
import { Languages } from "lucide-react";

// Shown when the interface language differs from the article language.
export const ArticleLangNote = ({ item, lang }) => {
  if (!item?.language || item.language === lang) return null;
  const fr = lang === "fr";
  const tr = item.translation?.language === lang ? item.translation : null;
  const text = tr
    ? (fr ? "Cet article existe aussi en français." : "This article is also available in English.")
    : item.language === "fr"
      ? (fr ? "Cet article n'existe qu'en français." : "This article is only available in French.")
      : (fr ? "Cet article n'existe qu'en anglais." : "This article is only available in English.");
  return (
    <div data-testid="article-lang-note" className="mt-6 flex flex-wrap items-center gap-2 border border-[#E5E7EB] bg-[#F7F7F2] px-4 py-3 text-[14px] text-[#111827]">
      <Languages size={16} className="text-[#00A878]" />
      <span>{text}</span>
      {tr && (
        <Link to={tr.path} data-testid="article-lang-note-link" className="font-semibold text-[#00A878] underline-offset-4 hover:underline">
          {fr ? "Lire la version française" : "Read the English version"}
        </Link>
      )}
    </div>
  );
};

export default ArticleLangNote;
